import React, { useEffect, useState } from "react";
import { CloseIcon } from "../../../../helper/HwIcon";

export const PersonsInfoModal = ({
  setFieldValue,
  values,
  onClose,
  hideInfants,
  data = {}
}) => {
  const [tempValues, setTempValues] = useState({
    numberOfAdults: values?.numberOfAdults,
    numberOfChild: values?.numberOfChild,
    numberOfInfants: values?.numberOfInfants
  });
  const [personError,setPersonError]=useState("")
  useEffect(() => {
    setTempValues({
      numberOfAdults: values?.numberOfAdults ?? 1,
      numberOfChild: values?.numberOfChild ?? 0,
      numberOfInfants: values?.numberOfInfants ?? 0,
    });
  }, [values]);

  let labels = {
    Adults: data?.excursion_ticket_adult_age_limit,
    Children: data?.excursion_ticket_child_age_limit,
    Infants: data?.excursion_ticket_infant_age_limit
  };

  const renderRow = (type, label) => {
    return (
      <div className="DT--passenger-item">
        <div className="DT--passenger-info">
          <div className="DT--passenger-label d-flex d-flex-column ml-6">
            <span>{tempValues?.[type] || ""} {label}</span>
            {labels?.[label] ? (
              <span className="hw-text12">{`(${labels?.[label]})`}</span>
            ) : ""}
          </div>
        </div>

        <div className="DT--counter">
          <button
            disabled={
              type === "numberOfAdults"
                ? tempValues?.[type] <= 1
                : tempValues?.[type] <= 0
            }
            onClick={(e) => {
              e.stopPropagation();
              setTempValues((prev) => ({
                ...prev,
                [type]: prev[type] - 1
              }));
            }}
          >
            -
          </button>

          <div className="DT--counter-display">
            <div className="DT--counter-value">
              <input
                min={type === "numberOfAdults" ? 1 : 0}
                type="number"
                step="1"
                value={tempValues?.[type]}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e" || e.key === "+" || e.key === "E") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  let inputValue = e.target.value;
                  if(inputValue === ''){
                    setTempValues((prev) => ({ ...prev, [type]: "" }));
                    return;
                  }
                  if (inputValue === '' || inputValue === '-' || inputValue === '+' || inputValue === 'E') {
                    return;
                  }
                  let cleanValue = inputValue.split('.')[0];
                  let val = parseInt(cleanValue, 10);
                  const minValue = type === "numberOfAdults" ? 1 : 0; 
                  if (!isNaN(val) && val >= minValue && Number.isInteger(val)) {
                    setTempValues((prev) => ({ ...prev, [type]: val }));
                  } else if (!isNaN(val) && val < minValue) {
                    setTempValues((prev) => ({ ...prev, [type]: minValue }));
                  }
                }}
                onBlur={(e) => {
                  let val = parseInt(e.target.value, 10);
                  const minValue = type === "numberOfAdults" ? 1 : 0;
                  if (isNaN(val) || val < minValue) {
                    setTempValues((prev) => ({ ...prev, [type]: minValue }));
                  } else if (!Number.isInteger(val)) {
                    setTempValues((prev) => ({ ...prev, [type]: Math.floor(val) }));
                  }
                }}
              />
            </div>
          </div>

          <button
            onClick={(e) => {
              e.stopPropagation();
              setTempValues((prev) => ({
                ...prev,
                [type]: prev[type] + 1
              }));
            }}
          >
            +
          </button>
        </div>

        <div className="DT--divider" />
      </div>
    );
  };

  return (
    <div
      className="DT--card-container"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="DT--section">
        {renderRow("numberOfAdults", "Adults")}
        {renderRow("numberOfChild", "Children")}
        {!hideInfants && renderRow("numberOfInfants", "Infants")}
      </div>

      <div className="DT--button-selector">
        {(personError) ? (
          <div class="hw-p-error-cls">{personError}</div>
        ) : null}
        <button
          onClick={() => {
            setTempValues({
              numberOfAdults: values.numberOfAdults,
              numberOfChild: values.numberOfChild,
              numberOfInfants: values.numberOfInfants,
            });
            setFieldValue("roomOptionModal", false);
            onClose?.();
          }}
          className="hw-btn hw-blue"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            setPersonError("")
            let total = tempValues?.numberOfAdults + tempValues?.numberOfChild + tempValues?.numberOfInfants
            if(tempValues?.numberOfAdults > 1000 || tempValues?.numberOfChild > 1000 || tempValues?.numberOfInfants > 1000 || total > 1000){
              setPersonError("Number of persons must not exceed 1,000")
              // onClose?.();
              return;
            }
            setFieldValue("numberOfAdults", tempValues.numberOfAdults);
            setFieldValue("numberOfChild", tempValues.numberOfChild);
            setFieldValue("numberOfInfants", tempValues.numberOfInfants);
            setFieldValue("roomOptionModal", false);
            onClose?.();
          }}
          className="hw-btn hw-btn--primary"
        >
          Done
        </button>
      </div>
    </div>
  );
};